import Container from 'react-bootstrap/Container'
import { Navbar, Nav, NavDropdown } from 'react-bootstrap'

function navbar() {
    return (<>
        <div className='header' style={{
            zIndex: '1',
            marginBottom: '-4rem',
            position: 'sticky', top: '0px'
        }}>
            <Navbar expand="lg" className="bg-dark" variant={'dark'} sticky="top">
                <Container fluid>
                    <Navbar.Brand href="/homeAdmin" style={{
                        fontFamily: 'sans-serif',
                        marginRight: '10%',
                        color: 'yellow'
                    }}>ADMIN</Navbar.Brand>
                    <Navbar.Toggle aria-controls="navbarScroll" />
                    <Navbar.Collapse id="navbarScroll">
                        <Nav
                            className="me-auto my-2 my-lg-0 navbarMargin"
                            style={{ maxHeight: '100%' }}
                        >
                            <Nav.Link href="/checkImg" style={{ marginRight: '5rem' }}>Check Img</Nav.Link>
                            <Nav.Link href="/addEvento" style={{ marginRight: '5rem' }}>Crea evento</Nav.Link>
                            <NavDropdown title="Food&Travel" style={{ marginRight: '5em' }}>
                                <NavDropdown.Item href="/addNewsletter" style={{ marginRight: '5rem' }}>Crea</NavDropdown.Item>
                                <NavDropdown.Item href="/EditNewsletter" style={{ marginRight: '5rem' }}>Edit</NavDropdown.Item>
                            </NavDropdown>
                            <NavDropdown title="Check Artisti/FoodTruck" style={{ marginRight: '5em' }}>
                                <NavDropdown.Item href="/checkArtisti">Check Artisti</NavDropdown.Item>
                                <NavDropdown.Item href="/checkFoodTruck">Check FoodTruck</NavDropdown.Item>
                                <NavDropdown.Item href="/checkRistoranti">Check Ristoranti</NavDropdown.Item>
                            </NavDropdown>
                            <NavDropdown title="Account" id="navbarScrollingDropdown" style={{ marginRight: '5rem' }}>
                                <NavDropdown.Item href="/logout">Logout</NavDropdown.Item>
                                <NavDropdown.Divider />
                                <NavDropdown.Item href="/logout">{localStorage.getItem('email')}</NavDropdown.Item>
                            </NavDropdown>
                            <NavDropdown title="Analitycs" id="navbarScrollingDropdown" style={{ marginRight: '5rem' }}>
                                <NavDropdown.Item href="/cercaEvento">CercaEvento</NavDropdown.Item>
                                <NavDropdown.Divider />
                                <NavDropdown.Item href="/commenti">Commenti</NavDropdown.Item>
                            </NavDropdown>
                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
        </div>
    </>)
}
export default navbar